import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  attributes: {
    display: 'flex',
    flexDirection: 'row',
  },
});
